import type { FC } from 'react';
import { memo } from 'react';
import HandwritingForm from './form';

import { NodePanelProps } from '../../types';
import type { HandWritingExtractionNodeType } from './types';

const Panel: FC<NodePanelProps<HandWritingExtractionNodeType>> = ({
  formRef,
  initialValue,
  node_id,
  readonly,
}) => {
  return (
    <HandwritingForm
      node_id={node_id}
      initialValue={initialValue}
      ref={formRef}
      readonly={readonly}
    />
  );
};

export default memo(Panel);
